// Copyright (c) 2017 Deere & Company

import Dealer, {getDefaultState as getDealerDefaultState} from './dealer';
import City from './city';
import t from 'tcomb';

const LeadAccount = t.struct({
    cities: t.list(City, 'Cities'),
    dealer: Dealer,
    id: t.String
}, {
    name: 'LeadAccount',
    strict: true
});

export const getDefaultState = () => new LeadAccount({
    cities: [],
    dealer: getDealerDefaultState(),
    id: ''
});

export default LeadAccount;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/lead-account.js